/**
 * Seal Subscription Bridge Script
 * TillyBare - Custom Subscribe & Save Checkbox
 * 
 * PRICING LOGIC (STACKING):
 * - Subscription = bundle_price × 0.8 (20% off the already-discounted bundle price)
 * - This means discounts STACK: bundle discount + subscription discount
 */

(function() {
  'use strict';

  // Configuration
  const SUBSCRIPTION_TEXT = 'Subscribe & Save';
  const SUBSCRIPTION_SUBTEXT = 'Free Lip Bomb + Auto-delivery';
  const SUBSCRIPTION_BADGE_TEXT = 'EXTRA 20% OFF';
  const SUBSCRIPTION_HEADER_TEXT = 'SUBSCRIBE — Cancel anytime';
  
  // State
  let isSubscriptionSelected = true;
  let sellingPlanId = null;
  let originalPrices = {};
  let subscriptionUnitPrice = null;
  let subscriptionDiscountFactor = 0.8; // Default 20% off
  let moneyFormat = '${{amount}}'; // Default format
  
  /**
   * Extract subscription unit price and discount factor from Seal widget
   */
  function extractSealData() {
    // Try multiple Seal widget selectors
    const sealWidget = document.querySelector('.sls-purchase-options-container') || 
                       document.querySelector('.sls-all-purchase-options');
    
    if (sealWidget) {
      // Get one-time price from Seal widget
      const oneTimeOption = sealWidget.querySelector('.sls-option-container[data-type="one-time"]') ||
        sealWidget.querySelector('.sls-option-container:last-child');
      let oneTimePrice = null;

      if (oneTimeOption) {
        const oneTimePriceEl = oneTimeOption.querySelector('.sls-price');
        if (oneTimePriceEl) {
          oneTimePrice = parsePrice(oneTimePriceEl.textContent);
        }
      }

      // Get subscription price
      const subscriptionOption = sealWidget.querySelector('.sls-option-container[data-selling-plan-group="0"]');
      if (subscriptionOption) {
        const priceEl = subscriptionOption.querySelector('.sls-price') ||
                        subscriptionOption.querySelector('.sls-selling-plan-group-price') ||
                        subscriptionOption.querySelector('.sls-comparison-price');
        
        if (priceEl) {
          subscriptionUnitPrice = parsePrice(priceEl.textContent);
          console.log('[TillyBare] Subscription unit price from Seal:', subscriptionUnitPrice);

          // Calculate discount factor dynamically
          if (oneTimePrice && oneTimePrice > 0) {
            subscriptionDiscountFactor = Math.min(subscriptionUnitPrice / oneTimePrice, 1.0);
            console.log('[TillyBare] Calculated discount factor:', subscriptionDiscountFactor, '(' + Math.round((1 - subscriptionDiscountFactor) * 100) + '% off)');
          }
        }
        
        // Get selling plan ID
        const sellingPlanInput = sealWidget.querySelector('input[name="selling_plan"]');
        if (sellingPlanInput && sellingPlanInput.value) {
          sellingPlanId = sellingPlanInput.value;
        }
      }
    }
    
    // FALLBACK: Calculate from 1x bundle price if Seal widget not found
    if (!subscriptionUnitPrice) {
      const firstBundle = document.querySelector('.quantity-break[data-quantity="1"]');
      if (firstBundle) {
        const priceEl = firstBundle.querySelector('.quantity-break__price');
        if (priceEl) {
          const oneTimePrice = parsePrice(priceEl.textContent);
          subscriptionUnitPrice = oneTimePrice * subscriptionDiscountFactor;
          console.log('[TillyBare] Calculated fallback unit price:', subscriptionUnitPrice);
        }
      }
    }
  }
  
  /**
   * Store original (one-time) bundle prices
   */
  function storeOriginalPrices() {
    document.querySelectorAll('.quantity-break').forEach((label, index) => {
      const priceEl = label.querySelector('.quantity-break__price');
      const comparePriceEl = label.querySelector('.quantity-break__compare-price');
      const captionEl = label.querySelector('.quantity-break__caption');
      const quantity = parseInt(label.getAttribute('data-quantity')) || 1;
      
      if (priceEl) {
        const priceText = priceEl.textContent.trim();
        const comparePriceText = comparePriceEl ? comparePriceEl.textContent.trim() : '';
        const numericPrice = parsePrice(priceText);
        const numericComparePrice = comparePriceText ? parsePrice(comparePriceText) : numericPrice;
        const captionText = captionEl ? captionEl.textContent.trim() : '';
        
        originalPrices[index] = {
          priceText: priceText,
          priceNumeric: numericPrice,
          comparePriceText: comparePriceText,
          comparePriceNumeric: numericComparePrice,
          captionText: captionText,
          quantity: quantity,
          priceEach: Math.round(numericPrice / quantity * 100) / 100
        };
      }
    });
    console.log('[TillyBare] Stored original prices:', originalPrices);
  }
  
  /**
   * Parse price string to numeric value
   */
  function parsePrice(priceStr) {
    if (!priceStr) return 0;
    // First strip everything before the first digit and after the last digit.
    // This removes currency symbols that contain dots (Dhs., Rs., Bs.) and
    // trailing text like " each | 47% OFF" that would pollute the numeric parse.
    let cleaned = priceStr.trim().replace(/^[^\d]*/, '').replace(/[^\d]*$/, '');
    // Now remove any remaining non-numeric characters except dots and commas
    const raw = cleaned.replace(/[^\d.,]/g, '');

    // If it has both . and , (e.g. 1.234,56 or 1,234.56)
    if (raw.includes('.') && raw.includes(',')) {
      const lastDot = raw.lastIndexOf('.');
      const lastComma = raw.lastIndexOf(',');
      if (lastDot > lastComma) {
        // Dot is decimal, comma is thousands (1,234.56)
        return parseFloat(raw.replace(/,/g, ''));
      } else {
        // Comma is decimal, dot is thousands (1.234,56)
        return parseFloat(raw.replace(/\./g, '').replace(',', '.'));
      }
    }

    // If it only has one type of separator or none
    const parts = raw.split(/[.,]/);
    if (parts.length > 2) {
      // Multiple dots or commas -> they are thousands separators (1.234.567 or 1,234,567)
      return parseFloat(raw.replace(/[.,]/g, ''));
    } else if (parts.length === 2) {
      // Single dot or comma. Use common knowledge for the currency context
      // But a safe bet is to check the length of the fractional part
      const fraction = parts[parts.length - 1];
      if (fraction.length === 2 || fraction.length === 1) {
        // Likely a decimal (e.g. 12.50 or 12,5)
        return parseFloat(raw.replace(',', '.'));
      } else {
        // Likely a thousands separator (e.g. 1.234 or 1,234)
        return parseFloat(raw.replace(/[.,]/g, ''));
      }
    }

    return parseFloat(raw) || 0;
  }
  
  /**
   * Universal money formatter based on Shopify's logic
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';

    function defaultOption(opt, def) {
      return typeof opt == 'undefined' ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return formatWithDelimiters(0, precision, thousands, decimal);
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? decimal + parts[1] : '';

      return dollars + cents;
    }

    const match = formatString.match(placeholderRegex);
    if (!match) return formatString;

    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  /**
   * Format price to match page currency format
   */
  function formatPrice(num) {
    if (isNaN(num)) return '';
    // Convert units to cents for formatMoney
    return formatMoney(Math.round(num * 100), moneyFormat);
  }
  
  /**
   * Update bundle prices based on subscription state
   */
  function updateBundlePrices() {
    const quantityBreaks = document.querySelectorAll('.quantity-break');
    
    quantityBreaks.forEach((label, index) => {
      const priceEl = label.querySelector('.quantity-break__price');
      const captionEl = label.querySelector('.quantity-break__caption');
      
      if (!priceEl || !originalPrices[index]) return;
      
      const original = originalPrices[index];
      const quantity = original.quantity;
      
      if (isSubscriptionSelected && subscriptionUnitPrice) {
        // STACKING LOGIC: Take the BUNDLE price and apply 20% subscription discount
        const subscriptionTotal = original.priceNumeric * subscriptionDiscountFactor;
        const stackedPriceEach = subscriptionTotal / quantity;

        priceEl.textContent = formatPrice(subscriptionTotal);
        
        if (captionEl) {
          const discountMatch = original.captionText.match(/(\d+%\s*OFF)/i);
          const bundleDiscount = discountMatch ? discountMatch[1] : '';
          // Show stacked price each with visual indicator
          captionEl.innerHTML = formatPrice(stackedPriceEach) + ' each | ' + bundleDiscount;
        }
        
        console.log('[TillyBare] Stacked', quantity + 'x to', formatPrice(subscriptionTotal));
      } else {
        // ONE-TIME: Restore original bundle prices
        priceEl.textContent = original.priceText;
        if (captionEl) {
          captionEl.textContent = original.captionText;
        }
      }
    });
    
    // Sync with hidden Seal widget
    syncWithSealWidget();
    // Update main product prices
    updateMainPrices();
  }

  /**
   * Updates the main product price at the top of the page and in the sticky ATC.
   */
  function updateMainPrices() {
    const selectedQtyInput = document.querySelector('input[name="quantity"]:checked');
    if (!selectedQtyInput) return;

    // Use indices to find the correct original price from stored prices
    const radioInputs = Array.from(document.querySelectorAll('input[name="quantity"]'));
    const index = radioInputs.indexOf(selectedQtyInput);

    if (index === -1 || !originalPrices[index]) {
      console.log('[TillyBare] Could not find original price for index:', index);
      return;
    }

    const original = originalPrices[index];
    let finalPrice = original.priceNumeric;
    let finalComparePrice = original.comparePriceNumeric;

    if (isSubscriptionSelected && subscriptionDiscountFactor) {
      finalPrice = original.priceNumeric * subscriptionDiscountFactor;
      finalComparePrice = original.comparePriceNumeric * subscriptionDiscountFactor;
    }

    const formattedPrice = formatPrice(finalPrice);
    const formattedComparePrice = formatPrice(finalComparePrice);

    // Update main regular/sale price items
    document.querySelectorAll('.main-price').forEach(el => {
      el.textContent = formattedPrice;
    });

    // Update main compare-at price items
    document.querySelectorAll('.main-comapre-price').forEach(el => {
      if (finalComparePrice > finalPrice) {
        el.textContent = formattedComparePrice;
        el.closest('.price__compare-price')?.classList.remove('hidden');
        el.closest('.price')?.classList.add('price--on-sale');
      } else {
        el.closest('.price__compare-price')?.classList.add('hidden');
        el.closest('.price')?.classList.remove('price--on-sale');
      }
    });

    // Update sticky ATC prices (handle both combined and separate items)
    document.querySelectorAll('[id^="sticky-atc-separate-price-"] .price-item, [id^="sticky-atc-price-"]').forEach(el => {
      // If it's the combined label in the button, it might contain the dot separator
      if (el.id && el.id.startsWith('sticky-atc-price-')) {
        const labelText = el.textContent;
        if (labelText.includes('•')) {
          el.innerHTML = `${formattedPrice} •`;
        } else {
          el.textContent = formattedPrice;
        }
      } else {
        el.textContent = formattedPrice;
      }
    });

    console.log(`[TillyBare] Updated main prices to ${formattedPrice} (Index: ${index}, Sub: ${isSubscriptionSelected})`);
  }
  
  /**
   * Sync our checkbox with Seal's hidden widget
   */
  function syncWithSealWidget() {
    const sealWidget = document.querySelector('.sls-purchase-options-container') ||
                       document.querySelector('.sls-all-purchase-options');
    if (!sealWidget) return;
    
    if (isSubscriptionSelected) {
      const subscriptionOption = sealWidget.querySelector('.sls-option-container[data-selling-plan-group="0"]');
      if (subscriptionOption && !subscriptionOption.classList.contains('sls-active')) {
        subscriptionOption.click();
      }
    } else {
      const oneTimeOption = sealWidget.querySelector('.sls-option-container input[data-type="one-time"]');
      if (oneTimeOption) {
        const container = oneTimeOption.closest('.sls-option-container');
        if (container && !container.classList.contains('sls-active')) {
          container.click();
        }
      }
    }
    
    setTimeout(updateSellingPlanInput, 50);
  }
  
  /**
   * Update selling_plan input in forms
   */
  function updateSellingPlanInput() {
    const forms = document.querySelectorAll('form[action*="/cart/add"], product-form form');
    
    forms.forEach(form => {
      let input = form.querySelector('input[name="selling_plan"]');
      
      if (isSubscriptionSelected) {
        const sealWidget = document.querySelector('.sls-purchase-options-container') ||
                           document.querySelector('.sls-all-purchase-options');
        const sealInput = sealWidget?.querySelector('input[name="selling_plan"]');
        const planId = sealInput?.value || sellingPlanId;
        
        if (planId) {
          if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'selling_plan';
            form.appendChild(input);
          }
          input.value = planId;
        }
      } else if (input) {
        input.value = '';
      }
    });
  }
  
  /**
   * Create custom checkbox UI - BELOW bundles
   */
  function createSubscriptionCheckbox() {
    if (document.getElementById('tillybare-subscription-toggle')) return;
    
    const quantityBreaks = document.querySelector('quantity-breaks, .quantity-breaks');
    if (!quantityBreaks) return;
    
    const container = document.createElement('div');
    container.id = 'tillybare-subscription-toggle';
    container.className = 'subscription-toggle subscription-toggle--checked';
    container.innerHTML = `
      <h3 class="quantity-breaks__title flex-center center">
        <span></span>
        <span>${SUBSCRIPTION_HEADER_TEXT}</span>
        <span></span>
      </h3>
      <label class="subscription-toggle__label" for="subscription-checkbox">
        <div class="subscription-toggle__checkbox-wrapper">
          <input type="checkbox" id="subscription-checkbox" checked>
          <span class="subscription-toggle__checkmark"></span>
        </div>
        <div class="subscription-toggle__text">
          <span class="subscription-toggle__title">${SUBSCRIPTION_TEXT} <span class="badge color-accent-2 subscription-toggle__badge">${SUBSCRIPTION_BADGE_TEXT}</span></span>
          <span class="subscription-toggle__subtitle">${SUBSCRIPTION_SUBTEXT}</span>
        </div>
      </label>
    `;
    
    if (!document.getElementById('subscription-toggle-styles')) {
      const styles = document.createElement('style');
      styles.id = 'subscription-toggle-styles';
      styles.textContent = `
        .subscription-toggle {
          margin-top: 24px;
          margin-bottom: 16px;
        }
        .subscription-toggle__label {
          display: flex;
          align-items: flex-start;
          gap: 12px;
          padding: 14px 16px;
          border: 1px solid #e0e0e0;
          border-radius: 8px;
          cursor: pointer;
          transition: border-color 0.2s ease, background-color 0.2s ease;
        }
        .subscription-toggle__label:hover {
          border-color: #000;
        }
        .subscription-toggle--checked .subscription-toggle__label {
          border-color: #000;
          background-color: #f9f9f9;
        }
        .subscription-toggle__checkbox-wrapper {
          position: relative;
          width: 20px;
          height: 20px;
          flex-shrink: 0;
          margin-top: 2px;
        }
        .subscription-toggle__checkbox-wrapper input {
          position: absolute;
          opacity: 0;
          width: 100%;
          height: 100%;
          cursor: pointer;
          z-index: 1;
        }
        .subscription-toggle__checkmark {
          position: absolute;
          top: 0;
          left: 0;
          width: 18px;
          height: 18px;
          border: 2px solid #000;
          border-radius: 3px;
          background: #fff;
        }
        .subscription-toggle--checked .subscription-toggle__checkmark {
          background: #000;
        }
        .subscription-toggle--checked .subscription-toggle__checkmark::after {
          content: '';
          position: absolute;
          left: 5px;
          top: 1px;
          width: 5px;
          height: 10px;
          border: solid #fff;
          border-width: 0 2px 2px 0;
          transform: rotate(45deg);
        }
        .subscription-toggle__text {
          display: flex;
          flex-direction: column;
          gap: 2px;
        }
        .subscription-toggle__title {
          font-weight: 600;
          font-size: 14px;
          color: #000;
        }
        .subscription-toggle__badge {
          display: inline-block;
          font-size: 10px;
          font-weight: 700;
          padding: 2px 6px;
          border-radius: 3px;
          margin-left: 6px;
          vertical-align: middle;
        }
        .subscription-toggle__subtitle {
          font-size: 12px;
          color: #666;
        }
      `;
      document.head.appendChild(styles);
    }
    
    // Insert AFTER quantity breaks
    quantityBreaks.parentNode.insertBefore(container, quantityBreaks.nextSibling);
    
    const checkbox = container.querySelector('#subscription-checkbox');
    checkbox.addEventListener('change', function() {
      isSubscriptionSelected = this.checked;
      container.classList.toggle('subscription-toggle--checked', isSubscriptionSelected);
      updateBundlePrices();
    });
    
    console.log('[TillyBare] Checkbox created');
  }
  
  /**
   * Initialize
   */
  function init() {
    console.log('[TillyBare] Initializing subscription bridge...');
    
    // Poll every 100ms until bundles are ready (max 5 seconds)
    const checkReady = setInterval(() => {
      const quantityBreaks = document.querySelector('quantity-breaks, .quantity-breaks');
      const bundleLabels = document.querySelectorAll('.quantity-break');
      
      if (quantityBreaks && bundleLabels.length > 0) {
        clearInterval(checkReady);
        
        // Wait 800ms for Seal widget to fully render before extracting data
        setTimeout(() => {
          // Capture money format from quantity-breaks element
          const qb = document.querySelector('quantity-breaks, .quantity-breaks');
          if (qb) {
            moneyFormat = qb.getAttribute('data-money-format') || moneyFormat;
            console.log('[TillyBare] Using money format from qb:', moneyFormat);
          }

          // Robust fallback detection
          if (moneyFormat === '${{amount}}') {
            const priceEl = document.querySelector('.price .money, [class*="price"]:not(.quantity-break__price)');
            if (priceEl) {
              const priceText = priceEl.textContent.trim();
              if (priceText.includes('€')) moneyFormat = '€{{amount}}';
              else if (priceText.includes('£')) moneyFormat = '£{{amount}}';
              else if (priceText.includes('RSD')) moneyFormat = '{{amount}} RSD';
              else if (priceText.match(/\d+,\d{2}\s*$/)) moneyFormat = '{{amount_with_comma_separator}}';
              console.log('[TillyBare] Detected fallback money format:', moneyFormat);
            }
          }

          storeOriginalPrices();
          extractSealData();
          createSubscriptionCheckbox();
          
          // Add event listeners for bundle selection changes
          document.querySelectorAll('input[name="quantity"]').forEach(input => {
            input.addEventListener('change', updateMainPrices);
          });

          if (isSubscriptionSelected) {
            updateBundlePrices();
          } else {
            updateMainPrices();
          }
          
          console.log('[TillyBare] Initialized. Unit price:', subscriptionUnitPrice);
        }, 800);
      }
    }, 100);
    
    // Stop polling after 5 seconds if bundles never load
    setTimeout(() => clearInterval(checkReady), 5000);
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
